{
  "growth-confluence-find.confluence-d1d6-back-to-product-email.message-template.email.icon-check-circle.alt-text": [
    {
      "type": 0,
      "value": "Icon - Check circle"
    }
  ],
  "growth-confluence-find.confluence-d1d6-back-to-product-no-nth-user-active.message-template.email.add-your-team.button-text": [
    {
      "type": 0,
      "value": "Let's go"
    }
  ],
  "growth-confluence-find.confluence-d1d6-back-to-product-no-nth-user-active.message-template.email.add-your-team.header": [
    {
      "type": 0,
      "value": "Confluence is better "
    },
    {
      "type": 1,
      "value": "lineBreak"
    },
    {
      "type": 0,
      "value": " when the team’s all in"
    }
  ],
  "growth-confluence-find.confluence-d1d6-back-to-product-no-nth-user-active.message-template.email.add-your-team.main-image.alt-text": [
    {
      "type": 0,
      "value": "Confluence cards showing tasks with assignees and different types of work"
    }
  ],
  "growth-confluence-find.confluence-d1d6-back-to-product-no-nth-user-active.message-template.email.add-your-team.pre-footer-header": [
    {
      "type": 0,
      "value": "Your team’s waiting for your great ideas!"
    }
  ],
  "growth-confluence-find.confluence-d1d6-back-to-product-no-nth-user-active.message-template.email.add-your-team.pre-footer-subtext": [
    {
      "type": 0,
      "value": "Jump back into Confluence and start collaborating today"
    }
  ],
  "growth-confluence-find.confluence-d1d6-back-to-product-no-nth-user-active.message-template.email.add-your-team.steps-1.description": [
    {
      "type": 0,
      "value": "Click "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Share"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " in Confluence to copy a link you can send in email, Slack or MS Teams"
    }
  ],
  "growth-confluence-find.confluence-d1d6-back-to-product-no-nth-user-active.message-template.email.add-your-team.steps-1.title": [
    {
      "type": 0,
      "value": "Link content to teammates"
    }
  ],
  "growth-confluence-find.confluence-d1d6-back-to-product-no-nth-user-active.message-template.email.add-your-team.steps-2.description": [
    {
      "type": 0,
      "value": "Give feedback on docs in progress, and @mention teammates to keep everyone in the loop"
    }
  ],
  "growth-confluence-find.confluence-d1d6-back-to-product-no-nth-user-active.message-template.email.add-your-team.steps-2.title": [
    {
      "type": 0,
      "value": "Comment in pages"
    }
  ],
  "growth-confluence-find.confluence-d1d6-back-to-product-no-nth-user-active.message-template.email.add-your-team.steps-3.description": [
    {
      "type": 0,
      "value": "Align on the best path forward by voting on ideas as a team in whiteboards"
    }
  ],
  "growth-confluence-find.confluence-d1d6-back-to-product-no-nth-user-active.message-template.email.add-your-team.steps-3.title": [
    {
      "type": 0,
      "value": "Vote in whiteboards"
    }
  ],
  "growth-confluence-find.confluence-d1d6-back-to-product-no-nth-user-active.message-template.email.add-your-team.steps-header": [
    {
      "type": 0,
      "value": "How to use Confluence "
    },
    {
      "type": 1,
      "value": "lineBreak"
    },
    {
      "type": 0,
      "value": " with your team:"
    }
  ],
  "growth-confluence-find.confluence-d1d6-back-to-product-no-nth-user-active.message-template.email.add-your-team.subtext": [
    {
      "type": 0,
      "value": "You’re creating awesome ideas in Confluence, "
    },
    {
      "type": 1,
      "value": "firstName"
    },
    {
      "type": 0,
      "value": ". It’s "
    },
    {
      "type": 1,
      "value": "lineBreak"
    },
    {
      "type": 0,
      "value": " time to share them with your team!"
    }
  ],
  "growth-confluence-find.confluence-d1d6-back-to-product-no-nth-user-active.message-template.email.subject.no-first-issue-assigned": [
    {
      "type": 0,
      "value": "👏 Your ideas deserve an audience, "
    },
    {
      "type": 1,
      "value": "firstName"
    }
  ],
  "growth-confluence-find.confluence-d1d6-back-to-product-no-page-created.message-template.email.add-your-team.button-text": [
    {
      "type": 0,
      "value": "Let's go"
    }
  ],
  "growth-confluence-find.confluence-d1d6-back-to-product-no-page-created.message-template.email.add-your-team.header": [
    {
      "type": 0,
      "value": "Get your ideas"
    },
    {
      "type": 1,
      "value": "lineBreak"
    },
    {
      "type": 0,
      "value": "on “paper”, "
    },
    {
      "type": 1,
      "value": "firstName"
    },
    {
      "type": 0,
      "value": "!"
    }
  ],
  "growth-confluence-find.confluence-d1d6-back-to-product-no-page-created.message-template.email.add-your-team.main-image.alt-text": [
    {
      "type": 0,
      "value": "Confluence cards showing tasks with assignees and different types of work"
    }
  ],
  "growth-confluence-find.confluence-d1d6-back-to-product-no-page-created.message-template.email.add-your-team.pre-footer-header": [
    {
      "type": 0,
      "value": "Ready to jump back in?"
    }
  ],
  "growth-confluence-find.confluence-d1d6-back-to-product-no-page-created.message-template.email.add-your-team.pre-footer-subtext": [
    {
      "type": 0,
      "value": "Go back to Confluence today to start doing your team’s best work"
    }
  ],
  "growth-confluence-find.confluence-d1d6-back-to-product-no-page-created.message-template.email.add-your-team.steps-1.description": [
    {
      "type": 0,
      "value": "Jot down & organize your ideas with sleek editor tools"
    }
  ],
  "growth-confluence-find.confluence-d1d6-back-to-product-no-page-created.message-template.email.add-your-team.steps-1.title": [
    {
      "type": 0,
      "value": "Start with a page"
    }
  ],
  "growth-confluence-find.confluence-d1d6-back-to-product-no-page-created.message-template.email.add-your-team.steps-2.description": [
    {
      "type": 0,
      "value": "@mention someone to show them what you’re working on"
    }
  ],
  "growth-confluence-find.confluence-d1d6-back-to-product-no-page-created.message-template.email.add-your-team.steps-2.title": [
    {
      "type": 0,
      "value": "Brainstorm with teammates"
    }
  ],
  "growth-confluence-find.confluence-d1d6-back-to-product-no-page-created.message-template.email.add-your-team.steps-3.description": [
    {
      "type": 0,
      "value": "Connect Slack, Microsoft, or Google to keep the whole team in sync"
    }
  ],
  "growth-confluence-find.confluence-d1d6-back-to-product-no-page-created.message-template.email.add-your-team.steps-3.title": [
    {
      "type": 0,
      "value": "Connect your tools"
    }
  ],
  "growth-confluence-find.confluence-d1d6-back-to-product-no-page-created.message-template.email.add-your-team.steps-header": [
    {
      "type": 0,
      "value": "Easy ways to get setup:"
    }
  ],
  "growth-confluence-find.confluence-d1d6-back-to-product-no-page-created.message-template.email.add-your-team.subtext": [
    {
      "type": 0,
      "value": "It only takes a minute to wrap up your Confluence setup. Jump back in now to start unleashing your team’s knowledge."
    }
  ],
  "growth-confluence-find.confluence-d1d6-back-to-product-no-page-created.message-template.email.subject.no-first-issue-assigned": [
    {
      "type": 0,
      "value": "👋 Almost there—need help setting up Confluence?"
    }
  ],
  "growth-confluence-find.confluence-d1d6-back-to-product-no-second-page-created.message-template.email.add-your-team.button-text": [
    {
      "type": 0,
      "value": "Let's go"
    }
  ],
  "growth-confluence-find.confluence-d1d6-back-to-product-no-second-page-created.message-template.email.add-your-team.header": [
    {
      "type": 0,
      "value": "It’s time to make your space, more spacious"
    }
  ],
  "growth-confluence-find.confluence-d1d6-back-to-product-no-second-page-created.message-template.email.add-your-team.main-image.alt-text": [
    {
      "type": 0,
      "value": "Confluence cards showing tasks with assignees and different types of work"
    }
  ],
  "growth-confluence-find.confluence-d1d6-back-to-product-no-second-page-created.message-template.email.add-your-team.pre-footer-header": [
    {
      "type": 0,
      "value": "Create a space everyone will rave about!"
    }
  ],
  "growth-confluence-find.confluence-d1d6-back-to-product-no-second-page-created.message-template.email.add-your-team.pre-footer-subtext": [
    {
      "type": 0,
      "value": "Create, organize & share to get the team’s ideas all out there"
    }
  ],
  "growth-confluence-find.confluence-d1d6-back-to-product-no-second-page-created.message-template.email.add-your-team.steps-1.description": [
    {
      "type": 0,
      "value": "Simply drag items around in the left-hand sidebar & click + to create something new to your space"
    }
  ],
  "growth-confluence-find.confluence-d1d6-back-to-product-no-second-page-created.message-template.email.add-your-team.steps-1.title": [
    {
      "type": 0,
      "value": "Drag, drop & create in context"
    }
  ],
  "growth-confluence-find.confluence-d1d6-back-to-product-no-second-page-created.message-template.email.add-your-team.steps-2.description": [
    {
      "type": 0,
      "value": "Add folders to create directories where everything’s stored. You can even convert pages to folders in the ... menu."
    }
  ],
  "growth-confluence-find.confluence-d1d6-back-to-product-no-second-page-created.message-template.email.add-your-team.steps-2.title": [
    {
      "type": 0,
      "value": "Pop it into a folder"
    }
  ],
  "growth-confluence-find.confluence-d1d6-back-to-product-no-second-page-created.message-template.email.add-your-team.steps-3.description": [
    {
      "type": 0,
      "value": "Create "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "smart links"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " to auto-pull content into Confluence from other tools your team already uses, like Google Docs or MS Excel"
    }
  ],
  "growth-confluence-find.confluence-d1d6-back-to-product-no-second-page-created.message-template.email.add-your-team.steps-3.title": [
    {
      "type": 0,
      "value": "Link from your favorite tools"
    }
  ],
  "growth-confluence-find.confluence-d1d6-back-to-product-no-second-page-created.message-template.email.add-your-team.steps-header": [
    {
      "type": 0,
      "value": "Tips for building out your team’s space:"
    }
  ],
  "growth-confluence-find.confluence-d1d6-back-to-product-no-second-page-created.message-template.email.add-your-team.subtext": [
    {
      "type": 0,
      "value": "Your "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "space"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " is like a hub for your team’s docs & resources. "
    },
    {
      "type": 1,
      "value": "lineBreak"
    },
    {
      "type": 0,
      "value": "Create more and organize it all in your space today!"
    }
  ],
  "growth-confluence-find.confluence-d1d6-back-to-product-no-second-page-created.message-template.email.icon-check-circle.alt-text": [
    {
      "type": 0,
      "value": "Icon - Check circle"
    }
  ],
  "growth-confluence-find.confluence-d1d6-back-to-product-no-second-page-created.message-template.email.subject.no-first-issue-assigned": [
    {
      "type": 0,
      "value": "🤩 Impressive work you’ve got there, "
    },
    {
      "type": 1,
      "value": "firstName"
    }
  ],
  "growth-confluence-find.confluence-d1d6-back-to-product-no-second-space.message-template.email.add-your-team.button-text": [
    {
      "type": 0,
      "value": "Let's go"
    }
  ],
  "growth-confluence-find.confluence-d1d6-back-to-product-no-second-space.message-template.email.add-your-team.header": [
    {
      "type": 0,
      "value": "Take your team’s knowledge"
    },
    {
      "type": 1,
      "value": "lineBreak"
    },
    {
      "type": 0,
      "value": " to the next level"
    }
  ],
  "growth-confluence-find.confluence-d1d6-back-to-product-no-second-space.message-template.email.add-your-team.main-image.alt-text": [
    {
      "type": 0,
      "value": "Confluence cards showing tasks with assignees and different types of work"
    }
  ],
  "growth-confluence-find.confluence-d1d6-back-to-product-no-second-space.message-template.email.add-your-team.pre-footer-header": [
    {
      "type": 0,
      "value": "Go ahead - unleash your team’s knowledge!"
    }
  ],
  "growth-confluence-find.confluence-d1d6-back-to-product-no-second-space.message-template.email.add-your-team.pre-footer-subtext": [
    {
      "type": 0,
      "value": "Speed up teamwork by building out your knowledge hub today"
    }
  ],
  "growth-confluence-find.confluence-d1d6-back-to-product-no-second-space.message-template.email.add-your-team.steps-1.description": [
    {
      "type": 0,
      "value": "Organize work for specific teams, projects and workstreams in separate spaces to create specialized knowledge repos"
    }
  ],
  "growth-confluence-find.confluence-d1d6-back-to-product-no-second-space.message-template.email.add-your-team.steps-1.title": [
    {
      "type": 0,
      "value": "More spaces = more knowledge sources"
    }
  ],
  "growth-confluence-find.confluence-d1d6-back-to-product-no-second-space.message-template.email.add-your-team.steps-2.description": [
    {
      "type": 0,
      "value": "Rovo Search helps any team instantly find the info they need in Confluence, Slack, MS Office, and more!"
    }
  ],
  "growth-confluence-find.confluence-d1d6-back-to-product-no-second-space.message-template.email.add-your-team.steps-2.title": [
    {
      "type": 0,
      "value": "Search across spaces & tools"
    }
  ],
  "growth-confluence-find.confluence-d1d6-back-to-product-no-second-space.message-template.email.add-your-team.steps-3.description": [
    {
      "type": 0,
      "value": "Need to make a page or presentation with info from multiple sources? Ask Rovo Chat to pull in knowledge from anywhere and auto-create it for you in a snap!"
    }
  ],
  "growth-confluence-find.confluence-d1d6-back-to-product-no-second-space.message-template.email.add-your-team.steps-3.title": [
    {
      "type": 0,
      "value": "Just ask Rovo"
    }
  ],
  "growth-confluence-find.confluence-d1d6-back-to-product-no-second-space.message-template.email.add-your-team.steps-header": [
    {
      "type": 0,
      "value": "Try out the knowledge hub basics:"
    }
  ],
  "growth-confluence-find.confluence-d1d6-back-to-product-no-second-space.message-template.email.add-your-team.subtext": [
    {
      "type": 0,
      "value": "Creating new spaces with even more Confluence content helps "
    },
    {
      "type": 1,
      "value": "lineBreak"
    },
    {
      "type": 0,
      "value": "unlock knowledge across every team!"
    }
  ],
  "growth-confluence-find.confluence-d1d6-back-to-product-no-second-space.message-template.email.icon-check-circle.alt-text": [
    {
      "type": 0,
      "value": "Icon - Check circle"
    }
  ],
  "growth-confluence-find.confluence-d1d6-back-to-product-no-second-space.message-template.email.subject.no-first-issue-assigned": [
    {
      "type": 0,
      "value": "🧙 Did you know? A knowledge hub makes work easier"
    }
  ],
  "growth-confluence-find.message-templates.confluence-notification-drawer-getting-started-nth-user.welcome-to-confluence": [
    {
      "type": 0,
      "value": "Welcome to Confluence, "
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": "! Learn how to create your first doc."
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.atlassian-address": [
    {
      "type": 0,
      "value": "341 George Street, Sydney, NSW, 2000, Australia"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.capture-your-ideas": [
    {
      "type": 0,
      "value": "Capture your ideas as a team in pages, whiteboards, and more today."
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.capture-your-thoughts": [
    {
      "type": 0,
      "value": "Capture your thoughts and ideas on docs and whiteboards."
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.collaborate-with-your-new-teammate": [
    {
      "type": 0,
      "value": "Collaborate with your new teammate on your next big idea today."
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.confluence-is": [
    {
      "children": [
        {
          "type": 0,
          "value": "Confluence is a collaborative workspace"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " where over 75,000+ customers create and organize knowledge with their team"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.copyright": [
    {
      "type": 0,
      "value": "Copyright "
    },
    {
      "type": 1,
      "value": "year"
    },
    {
      "type": 0,
      "value": " Atlassian Pty Ltd. All rights reserved."
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.create-with-a-template": [
    {
      "type": 0,
      "value": "Create with a template"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.customer-logos.alt": [
    {
      "type": 0,
      "value": "Customer logos including Twilio, NASA, Illumina, Docker, and Morningstar"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.forward-invite-banner": [
    {
      "type": 0,
      "value": "👋 "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Forward this email"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " to easily invite more teammates"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.get-started-at-lightning-speed": [
    {
      "type": 0,
      "value": "⚡ Get started at lightning speed with a template"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.get-your-ideas-on-paper": [
    {
      "type": 0,
      "value": "Get your ideas on \"paper\" with pages, whiteboards, and more in Confluence today."
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.great-job-adding": [
    {
      "type": 0,
      "value": "Great job adding your work to your Confluence space!"
    },
    {
      "children": [
      ],
      "type": 8,
      "value": "br"
    },
    {
      "type": 0,
      "value": "Invite a teammate to get feedback on it today."
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.great-momentum": [
    {
      "type": 0,
      "value": "Great momentum, "
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": "! Keep it going with a template"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.great-work": [
    {
      "type": 0,
      "value": "🤩 Great work—Your space deserves an audience"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.invite-teammates": [
    {
      "type": 0,
      "value": "Invite teammates"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.invite-your-teammates": [
    {
      "type": 0,
      "value": "Invite your teammates to collaborate and align on ideas quickly."
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.jump-back-in": [
    {
      "type": 0,
      "value": "Jump back in"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.kick-off-collaboration": [
    {
      "type": 0,
      "value": "Kick off collaboration with your new teammate, "
    },
    {
      "type": 1,
      "value": "name"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.last-edited": [
    {
      "type": 0,
      "value": "Last edited "
    },
    {
      "type": 1,
      "value": "relativeTime"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.last-edited.shortJustNow": [
    {
      "type": 0,
      "value": "just now"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.last-edited.shortXDaysAgo": [
    {
      "type": 1,
      "value": "timeAgo"
    },
    {
      "type": 0,
      "value": "d ago"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.last-edited.shortXHoursAgo": [
    {
      "type": 1,
      "value": "timeAgo"
    },
    {
      "type": 0,
      "value": "h ago"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.last-edited.shortXMinutesAgo": [
    {
      "type": 1,
      "value": "timeAgo"
    },
    {
      "type": 0,
      "value": "m ago"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.lets-create-your-next": [
    {
      "type": 0,
      "value": "Let's create your next big idea, "
    },
    {
      "type": 1,
      "value": "name"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.nows-the-time": [
    {
      "type": 0,
      "value": "⏰ Now's the time to create something great as a team"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.one-new-teammate": [
    {
      "type": 0,
      "value": "1 new teammate joined your Confluence space. Capture your next big idea with them in pages, whiteboards, and more today."
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.or-share-this-link": [
    {
      "type": 0,
      "value": "Or share this link:"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.save-time-with": [
    {
      "type": 0,
      "value": "Save time with these templates"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.share-your-work": [
    {
      "type": 0,
      "value": "Share your work with the team, "
    },
    {
      "type": 1,
      "value": "name"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.space": [
    {
      "type": 1,
      "value": "spaceName"
    },
    {
      "type": 0,
      "value": " space"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.start-creating-fast": [
    {
      "type": 0,
      "value": "Start creating fast with templates recommended for your team."
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.team": [
    {
      "type": 0,
      "value": "Team"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.90-day-plan": [
    {
      "type": 0,
      "value": "90-day plan"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.all-hands-meeting": [
    {
      "type": 0,
      "value": "All hands meeting"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.annual-plan-one-pager": [
    {
      "type": 0,
      "value": "Annual plan one-pager"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.aws-architecture-diagram": [
    {
      "type": 0,
      "value": "AWS architecture diagram"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.business-plan-one-pager": [
    {
      "type": 0,
      "value": "Business plan one-pager"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.business-status-update": [
    {
      "type": 0,
      "value": "Business status update"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.career-development-plan": [
    {
      "type": 0,
      "value": "Career development plan"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.competitive-analysis": [
    {
      "type": 0,
      "value": "Competitive analysis"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.content-design-glossary": [
    {
      "type": 0,
      "value": "Content design glossary"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.content-strategy": [
    {
      "type": 0,
      "value": "Content strategy"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.customer-impact-assessment": [
    {
      "type": 0,
      "value": "Customer impact assessment"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.customer-interview-report": [
    {
      "type": 0,
      "value": "Customer interview report"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.daci-decision-documentation": [
    {
      "type": 0,
      "value": "DACI: decision documentation"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.design-decision": [
    {
      "type": 0,
      "value": "Design decision"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.design-review": [
    {
      "type": 0,
      "value": "Design review"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.design-sprint": [
    {
      "type": 0,
      "value": "Design sprint"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.design-systems": [
    {
      "type": 0,
      "value": "Design systems"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.devops-runbook": [
    {
      "type": 0,
      "value": "DevOps runbook"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.disruptive-brainstorming": [
    {
      "type": 0,
      "value": "Disruptive brainstorming"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.employee-handbook": [
    {
      "type": 0,
      "value": "Employee handbook"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.end-of-week-status-report": [
    {
      "type": 0,
      "value": "End of week status report"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.executive-business-review": [
    {
      "type": 0,
      "value": "Executive business review"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.hiring-process": [
    {
      "type": 0,
      "value": "Hiring process"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.how-to-article": [
    {
      "type": 0,
      "value": "How-to article"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.hr-knowledge-base-management": [
    {
      "type": 0,
      "value": "HR knowledge base management"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.incident-communication": [
    {
      "type": 0,
      "value": "Incident communication"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.incident-postmortem": [
    {
      "type": 0,
      "value": "Incident postmortem"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.itsm-change-management": [
    {
      "type": 0,
      "value": "ITSM change management"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.itsm-known-errors": [
    {
      "type": 0,
      "value": "ITSM known errors"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.itsm-post-incident-reviews": [
    {
      "type": 0,
      "value": "ITSM post incident reviews"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.itsm-runbook": [
    {
      "type": 0,
      "value": "ITSM runbook"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.itsm-weekly-major-incident-report": [
    {
      "type": 0,
      "value": "ITSM weekly major incident report"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.job-description": [
    {
      "type": 0,
      "value": "Job description"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.lennys-performance-review": [
    {
      "type": 0,
      "value": "Lenny's performance review"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.lennys-product-requirements": [
    {
      "type": 0,
      "value": "Lenny's product requirements"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.marketing-blog-post": [
    {
      "type": 0,
      "value": "Marketing blog post"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.marketing-campaign": [
    {
      "type": 0,
      "value": "Marketing campaign"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.marketing-plan": [
    {
      "type": 0,
      "value": "Marketing plan"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.meeting-notes": [
    {
      "type": 0,
      "value": "Meeting notes"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.message-house": [
    {
      "type": 0,
      "value": "Message house"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.mutual-action-plan": [
    {
      "type": 0,
      "value": "Mutual action plan"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.okrs": [
    {
      "type": 0,
      "value": "OKRs"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.persona": [
    {
      "type": 0,
      "value": "Persona"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.presenter-mode": [
    {
      "type": 0,
      "value": "Presenter mode"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.product-requirements": [
    {
      "type": 0,
      "value": "Product requirements"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.product-roadmap": [
    {
      "type": 0,
      "value": "Product roadmap"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.project-kickoff": [
    {
      "type": 0,
      "value": "Project kickoff"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.project-plan": [
    {
      "type": 0,
      "value": "Project plan"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.project-status": [
    {
      "type": 0,
      "value": "Project status"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.project-timeline-template": [
    {
      "type": 0,
      "value": "Project timeline"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.qtc-acquisition": [
    {
      "type": 0,
      "value": "QTC acquisition"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.quarterly-check-in": [
    {
      "type": 0,
      "value": "Quarterly check in"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.remote-team-meeting": [
    {
      "type": 0,
      "value": "Remote team meeting"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.risk-assessment-matrix": [
    {
      "type": 0,
      "value": "Risk assessment matrix"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.roles-and-responsibilities-play": [
    {
      "type": 0,
      "value": "Roles and responsibilities play"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.sales-account-planning": [
    {
      "type": 0,
      "value": "Sales account planning"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.sales-portal": [
    {
      "type": 0,
      "value": "Sales portal"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.service-team-health-monitor": [
    {
      "type": 0,
      "value": "Service team health monitor"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.smart-goals": [
    {
      "type": 0,
      "value": "SMART goals"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.software-architecture-review": [
    {
      "type": 0,
      "value": "Software architecture review"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.sprint-planning-meeting": [
    {
      "type": 0,
      "value": "Sprint planning meeting"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.stakeholder-communications": [
    {
      "type": 0,
      "value": "Stakeholder communications"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.standard-operating-procedure": [
    {
      "type": 0,
      "value": "Standard operating procedure (SOP)"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.strategic-plan": [
    {
      "type": 0,
      "value": "Strategic plan"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.swot-analysis": [
    {
      "type": 0,
      "value": "SWOT analysis"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.team-homepage": [
    {
      "type": 0,
      "value": "Team homepage"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.team-poster": [
    {
      "type": 0,
      "value": "Team poster"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.to-do-list": [
    {
      "type": 0,
      "value": "To-do list"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.troubleshooting-article": [
    {
      "type": 0,
      "value": "Troubleshooting article"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.vendor-agreement": [
    {
      "type": 0,
      "value": "Vendor agreement"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.virtual-event": [
    {
      "type": 0,
      "value": "Virtual event"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.vision-to-values": [
    {
      "type": 0,
      "value": "Vision to values"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.weekly-meeting-notes": [
    {
      "type": 0,
      "value": "Weekly meeting notes"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.work-trip-planner": [
    {
      "type": 0,
      "value": "Work trip planner"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.workshop-planner": [
    {
      "type": 0,
      "value": "Workshop planner"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.writing-guidelines": [
    {
      "type": 0,
      "value": "Writing guidelines"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.unsubscribe": [
    {
      "children": [
        {
          "type": 0,
          "value": "Unsubscribe"
        }
      ],
      "type": 8,
      "value": "a"
    },
    {
      "type": 0,
      "value": " to opt out of future emails like this."
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.use-template": [
    {
      "type": 0,
      "value": "Use template"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.we-recommend-starting": [
    {
      "type": 0,
      "value": "We recommend starting with these templates for your team:"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.we-recommend-these-templates": [
    {
      "type": 0,
      "value": "We recommend these templates for your team:"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.4ls-retro": [
    {
      "type": 0,
      "value": "4 Ls Retro"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.action-plan": [
    {
      "type": 0,
      "value": "Action plan"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.annual-calendar-2025-2026": [
    {
      "type": 0,
      "value": "Annual Calendar"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.brainwriting": [
    {
      "type": 0,
      "value": "Brainwriting"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.concept-map": [
    {
      "type": 0,
      "value": "Concept map"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.crazy-8s": [
    {
      "type": 0,
      "value": "Crazy 8s brainstorming"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.disruptive-brainstorm": [
    {
      "type": 0,
      "value": "Disruptive brainstorm"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.elevator-pitch": [
    {
      "type": 0,
      "value": "Elevator pitch"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.executive-summary": [
    {
      "type": 0,
      "value": "Executive summary"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.fishbone-diagram": [
    {
      "type": 0,
      "value": "Fishbone diagram"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.flow-chart": [
    {
      "type": 0,
      "value": "Flowchart"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.focus-area-diagram": [
    {
      "type": 0,
      "value": "Focus area diagram"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.gap-analysis": [
    {
      "type": 0,
      "value": "Gap analysis"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.health-monitor": [
    {
      "type": 0,
      "value": "Team health monitor"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.ice-breakers": [
    {
      "type": 0,
      "value": "Icebreakers"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.incident-postmortem": [
    {
      "type": 0,
      "value": "Incident postmortem"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.network-of-teams": [
    {
      "type": 0,
      "value": "Network of teams"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.org-chart": [
    {
      "type": 0,
      "value": "Org chart"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.prioritization": [
    {
      "type": 0,
      "value": "Prioritization matrix"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.product-roadmap": [
    {
      "type": 0,
      "value": "Product roadmap"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.product-vision-board": [
    {
      "type": 0,
      "value": "Product vision board"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.root-cause-analysis": [
    {
      "type": 0,
      "value": "Root cause analysis"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.service-blueprint": [
    {
      "type": 0,
      "value": "Service blueprint"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.simple-retrospective": [
    {
      "type": 0,
      "value": "Simple retrospective"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.stakeholder-mapping": [
    {
      "type": 0,
      "value": "Stakeholder mapping"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.swimlanes": [
    {
      "type": 0,
      "value": "Swimlanes process map"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.swot-analysis": [
    {
      "type": 0,
      "value": "SWOT Analysis"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.team-formation-guide": [
    {
      "type": 0,
      "value": "Team charter template"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.timeline-workflow": [
    {
      "type": 0,
      "value": "Timeline workflow"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.user-story-map": [
    {
      "type": 0,
      "value": "User story map"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.workflow": [
    {
      "type": 0,
      "value": "Workflow"
    }
  ],
  "growth-confluence-find.message-templates.confluence-nudge-complete-fo.youre-off-to-a-great-start": [
    {
      "type": 0,
      "value": "🚀 You're off to a great start—Let's start creating"
    }
  ],
  "post-office.growth-confluence-find.connect-tools-spotlight.body": [
    {
      "type": 0,
      "value": "Connect your team's most used apps to get better answers and more results across Search and Chat."
    }
  ],
  "post-office.growth-confluence-find.connect-tools-spotlight.headline": [
    {
      "type": 0,
      "value": "Search across tools"
    }
  ],
  "post-office.growth-confluence-find.connect-tools-spotlight.primary-action": [
    {
      "type": 0,
      "value": "Setup"
    }
  ],
  "post-office.growth-confluence-find.flag-to-share.copied": [
    {
      "type": 0,
      "value": "Copied!"
    }
  ],
  "post-office.growth-confluence-find.flag-to-share.copy-link": [
    {
      "type": 0,
      "value": "Copy link"
    }
  ],
  "post-office.growth-confluence-find.flag-to-share.first.database.description": [
    {
      "type": 0,
      "value": "Add your teammates so you can collaborate and stay in sync."
    }
  ],
  "post-office.growth-confluence-find.flag-to-share.first.database.primary-action": [
    {
      "type": 0,
      "value": "Share database"
    }
  ],
  "post-office.growth-confluence-find.flag-to-share.first.database.title": [
    {
      "type": 0,
      "value": "You've created your first database"
    }
  ],
  "post-office.growth-confluence-find.flag-to-share.first.live-doc.description": [
    {
      "type": 0,
      "value": "Add your teammates so you can collaborate and stay in sync."
    }
  ],
  "post-office.growth-confluence-find.flag-to-share.first.live-doc.primary-action": [
    {
      "type": 0,
      "value": "Share doc"
    }
  ],
  "post-office.growth-confluence-find.flag-to-share.first.live-doc.title": [
    {
      "type": 0,
      "value": "You've created your first live doc"
    }
  ],
  "post-office.growth-confluence-find.flag-to-share.first.whiteboard.description": [
    {
      "type": 0,
      "value": "Add your teammates so you can collaborate together in real time."
    }
  ],
  "post-office.growth-confluence-find.flag-to-share.first.whiteboard.primary-action": [
    {
      "type": 0,
      "value": "Share whiteboard"
    }
  ],
  "post-office.growth-confluence-find.flag-to-share.first.whiteboard.title": [
    {
      "type": 0,
      "value": "You've created your first whiteboard"
    }
  ],
  "post-office.growth-confluence-find.flag-to-share.second.land.database.description": [
    {
      "type": 0,
      "value": "Share this database with your teammates, so everyone can contribute and stay in sync."
    }
  ],
  "post-office.growth-confluence-find.flag-to-share.second.land.live-doc.description": [
    {
      "type": 0,
      "value": "Share this doc with your teammates, so everyone has the same context."
    }
  ],
  "post-office.growth-confluence-find.flag-to-share.second.land.whiteboard.description": [
    {
      "type": 0,
      "value": "Share this whiteboard with your teammates, so you can brainstorm together in real time."
    }
  ],
  "post-office.growth-confluence-find.flag-to-share.second.primary-action": [
    {
      "type": 0,
      "value": "Share"
    }
  ],
  "post-office.growth-confluence-find.flag-to-share.second.title": [
    {
      "type": 0,
      "value": "Collaborate with your team"
    }
  ],
  "post-office.growth-confluence-find.flag-to-share.second.xflow.database.description": [
    {
      "type": 0,
      "value": "Share this database with your Jira team, so they can contribute and stay in sync."
    }
  ],
  "post-office.growth-confluence-find.flag-to-share.second.xflow.live-doc.description": [
    {
      "type": 0,
      "value": "Share this doc with your Jira teammates, so everyone has the same project info."
    }
  ],
  "post-office.growth-confluence-find.flag-to-share.second.xflow.whiteboard.description": [
    {
      "type": 0,
      "value": "Share this whiteboard with your Jira team, so you can brainstorm together in real time."
    }
  ],
  "post-office.growth-confluence-find.invite-reminder-flag.description": [
    {
      "type": 0,
      "value": "Don't miss out on project updates and decisions from your teammates"
    }
  ],
  "post-office.growth-confluence-find.invite-reminder-flag.primary-action": [
    {
      "type": 0,
      "value": "Join your team"
    }
  ],
  "post-office.growth-confluence-find.invite-reminder-flag.title-team-invited": [
    {
      "type": 0,
      "value": "Your team invited you to Confluence"
    }
  ],
  "post-office.growth-confluence-find.invite-reminder-flag.title-user-invited": [
    {
      "type": 1,
      "value": "adminName"
    },
    {
      "type": 0,
      "value": " invited you to Confluence"
    }
  ]
}